class HowItWorks extends HTMLElement {
  constructor() {
    super();

    this.handleBlockMouseEnter = this.handleBlockMouseEnter.bind(this);
    this.handleBlockMouseLeave = this.handleBlockMouseLeave.bind(this);
  }

  connectedCallback() {
    this.blocks = this.querySelectorAll(".bosHowItWorksBlockContent");

    this.blocks.forEach((block) => {
      block.addEventListener("mouseenter", this.handleBlockMouseEnter);
      block.addEventListener("mouseleave", this.handleBlockMouseLeave);
    });
  }

  handleBlockMouseEnter(event) {
    const currentBlock = event.currentTarget;
    const text = currentBlock.querySelector(".bosHowItWorksBlockText");

    this.classList.add("isHovering");

    this.blocks.forEach((block) => {
      block.classList.toggle("isActive", block === currentBlock);
    });

    if (text) {
      text.style.maxHeight = text.scrollHeight + "px";
      text.classList.add("isVisible");
    }
  }

  handleBlockMouseLeave(event) {
    const text = event.currentTarget.querySelector(".bosHowItWorksBlockText");

    this.classList.remove("isHovering");

    this.blocks.forEach((block) => {
      block.classList.remove("isActive");
    });

    if (text) {
      text.style.maxHeight = "0px";
      text.classList.remove("isVisible");
    }
  }
}

if (!customElements.get("how-it-works")) {
  customElements.define("how-it-works", HowItWorks);
}
